import { DecimalFormatterService } from "./../../shared/models/decimal-formatter.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { WeGoConfig } from "./../../shared/config";
import { SearchBookingModel } from "./../../booking/models/search-booking.model";
import { VehicleOverviewModel } from "./../../booking/models/vehicle-overview.model";
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from "@angular/core";
import { BookingService } from "../../booking/models/booking.service";
const moment = require("moment");
const $ = require("jquery");

@Component({
  selector: "wego-vehicle-overview-driver",
  template: require('../views/vehicle-overview-driver.component.html'),
  styles: [
    `
      .media {
        padding: 10px;
        border: 1px solid #ddd;
      }

      span.label.label-default {
        font-size: 13px;
        line-height: 35px;
        background-color: #eeeeee;
        color: #2ba2aa;
        margin-right: 5px;
      }

      span.label.label-default.text-success {
        color: #3c763d;
      }

      span.label.label-default.text-danger {
        color: #a94442;
      }

      .progress-bar-success {
        background-color: #2ba2aa;
      }
      .dropdown {
        position: relative;
        display: inline-block;
      }

      .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        min-width: 105px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        padding: 12px 16px;
        z-index: 1;
      }

      .dropdown:hover .dropdown-content {
        display: block;
      }
    `
  ]
})
export class VehicleOverviewDriverComponent implements OnInit, OnChanges {
  @Output("OnBook") onBook = new EventEmitter();
  @Input("VehicleOverviewList") vehicleOverviewList: VehicleOverviewModel[];
  @Input("SearchBookingModel") searchBookingModel: SearchBookingModel;
  @ViewChild("calanderpopup") public calanderpopup: any;

  LblKM: string;
  LblLocationUnavailable: string;
  LblAvailibilityCalander: string;
  isLoading: boolean;
  SortByDistance: boolean = true;

  constructor(
    private translate: TranslateService,
    private bookingService: BookingService,
    private decimalFormatter: DecimalFormatterService
  ) {}

  ngOnChanges(change: any) {}

  ngOnInit() {
    this.LblKM = this.translate.instant("LblKM");
    this.LblLocationUnavailable = this.translate.instant(
      "LblLocationUnavailable"
    );
    this.LblAvailibilityCalander = this.translate.instant(
      "LblAvailabilityCalander"
    );
    this.SortList();
  }

  public BookVehicle(sharedVehicleGroupHashID: any, vehicleHashID: any) {
    this.onBook.emit({
      SharedVehicleGroupHashID: sharedVehicleGroupHashID,
      VehicleHashID: vehicleHashID
    });
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = "vehicleAttributeCategoryName";
      return vehicleAttributeList.reduce(function(groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }

  public PrintLocation(item: VehicleOverviewModel) {
    if (item.address && item.lat != 0 && item.long != 0) {
      return (
        item.address +
        " (" +
        this.decimalFormatter.transform(item.distance) +
        " " +
        this.LblKM +
        ")"
      );
    } else {
      return this.LblLocationUnavailable;
    }
  }
  public OpenAvailabilityCalander(vehcleHashId: string, licenceTag: string) {
    this.isLoading = true;
    this.bookingService
      .GetAquiredTimeSlots(
        vehcleHashId,
        this.searchBookingModel.driverHashId,
        this.searchBookingModel.organizationIdHashID
      )
      .subscribe(
        res => {
          if (res.data) {
            this.calanderpopup.occupiedTime = res.data;
            this.calanderpopup.licenceTag = licenceTag;
            res.data.forEach((x: any) => {
              this.calanderpopup.driverName = x.driverName;
              this.calanderpopup.email = x.email;
              this.calanderpopup.mobileNumber = x.mobile;
            });

            this.calanderpopup.popupTitle = this.LblAvailibilityCalander;
            this.calanderpopup.show();
            this.isLoading = false;
          }
        },
        error => {}
      );
  }
  private OnSort() {
    if ($("#sortByDDL").val() == "avaibility") {
      this.SortByDistance = false;
      this.SortList();
    } else if ($("#sortByDDL").val() == "distance") this.SortByDistance = true;
    this.SortList();
  }

  private SortList() {
    this.vehicleOverviewList = this.vehicleOverviewList.sort(
      (x: VehicleOverviewModel, y: VehicleOverviewModel) =>
        this.HandleSorting(x, y)
    );
  }

  HandleSorting(obj1: any, obj2: any) {
    let val1 = this.SortByDistance
      ? obj1.distance == "NaN"
        ? Infinity
        : obj1.distance
      : obj1.nextAvailableFromTime
        ? moment(obj1.nextAvailableFromTime, "DD-MM-YYYY HH:mm")
        : moment("01-01-1900 00:00");
    let val2 = this.SortByDistance
      ? obj2.distance == "NaN"
        ? Infinity
        : obj2.distance
      : obj2.nextAvailableFromTime
        ? moment(obj2.nextAvailableFromTime, "DD-MM-YYYY HH:mm")
        : moment("01-01-1900 00:00");

    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-driver/components/vehicle-overview-driver.component.ts